import React from "react";
import { Modal, ActivityIndicator, View } from "react-native";
import tw from "twrnc";

export const LoadingOverlay = ({ loading }) => {
  return (
    <Modal
      transparent
      animationType="none"
      visible={loading}
      onRequestClose={() => {}}
    >
      <View style={tw`flex-1 items-center flex-row justify-around bg-black/40`}>
        <View
          style={tw`bg-white h-[100px] w-[100px] rounded-[10px] flex items-center justify-around`}
        >
          <ActivityIndicator animating={loading} size="large" color="#F84123" />
        </View>
      </View>
    </Modal>
  );
};
